import React ,{ useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import './App.css';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import ToolBox from './viewer/ToolBox.js';
import { setAuthInfo, setLoading, setBookmarkList} from './actions/main.js'
import { setSearchKeySelect, setSearchPulldownValue, setSearchOptions } from './actions/searchbox'
import { setOpenCompanyProfile, setCustomStyles } from './actions/ui.js'
import { getTokenPlanner, getTokenCookie, setCookie,assetUrl,formatDateRange } from './utils/Common.js'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import DownloadIcon from '@mui/icons-material/Download';
import VideocamIcon from '@mui/icons-material/Videocam';
import {
  BrowserRouter as Router,
  Link,
  useLocation
} from "react-router-dom";
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import LeftProfile from  './viewer/component/LeftProfile.js';
import { useParams } from 'react-router-dom'
import { API_URL, ESHOW_URL } from './config.js'
import ReactPlayer from 'react-player'
import { makeStyles } from '@mui/styles';
import ReactReadMoreReadLess from "react-read-more-read-less";
import Footer from './viewer/component/Footer.js';
import SearchBox from './viewer/component/SearchBox.js';
import qs from 'qs'
import axiosInstance from './utils/axiosInstance.js'
import IconButton from '@mui/material/IconButton';
import BookmarkBorderSharpIcon from '@mui/icons-material/BookmarkBorderSharp';
import BookmarkSharpIcon from '@mui/icons-material/BookmarkSharp';

const moment = require('moment-timezone');

function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function Index(props) {
  const { id1, id2, id3, id4, id5 } = useParams();
  let query = useQuery();
  const [data, setData] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [page, setPage] = React.useState(1);
  const [filteredItems, setFilteredItems] = useState([])
  const page_size = 24;

  let standardSearchOptions = props.searchbox.searchOptions?.STANDARD??[]
  let keySelect = props.searchbox?.searchKeySelect
  let pulldownValue = props.searchbox?.searchPulldownValue
  let searchInputValue = props.searchbox?.searchInputValue
  var selectedAdvancedFilterOptions = props.searchbox.selectedAdvancedFilterOptions
  
  const useStyles = makeStyles((theme) => ({
    searchBtn:{
      backgroundColor: props.ui?.customStyles?.['search-button-bg-color']?(props.ui?.customStyles['search-button-bg-color']+"!important"):'#1565c0',
      color: props.ui?.customStyles?.['search-button-label-color']?(props.ui?.customStyles['search-button-label-color']+"!important"):'#1565c0',
    },
    bubble:{
      color:props.ui?.customStyles?.['bubble-label-color']?(props.ui?.customStyles['bubble-label-color']+"!important"):'white',
      backgroundColor:props.ui?.customStyles?.['bubble-bg-color']?(props.ui?.customStyles['bubble-bg-color']+"!important"):'#1565c0',
    }
  }));
  const classes = useStyles();
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const openCompanyProfile=(exhibitor)=>{   
    var booth = {};
    booth.exhibitors = [{EXHIBITOR_KEY: exhibitor.exhibitor_key}]
    booth.booth_number = exhibitor?.booth_no

    props.setOpenCompanyProfile({booth:booth, open:true})
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display:'block'
  }));

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const fetchData = ()=>{    
    if(props.urlToken){
      var public_token = `/${id1}`
        if(id2){
          public_token = `${public_token}/${id2}`
        }
        if(id3){
          public_token = `${public_token}/${id3}`
        }
        if(id4){
          public_token = `${public_token}/${id4}`
        }
        if(id5){
          public_token = `${public_token}/${id5}`
        }
        setCookie('V3PUBLICMAP', public_token)
    }
    props.setLoading(true)
    var url = `${ESHOW_URL()}?method=getExhibitorEvents` 
    const options = {
      headers: {
        'Authorization': `Bearer ${getTokenCookie()}`
      }
    } 
    axios.get(url, options).then(res=>{
        const result = res.data;
        props.setSearchOptions(result.SEARCH) 
        // if(result.SUCCESS){  
          if(result.EVENTS){
            setData(result.EVENTS) 
            fetchBookmarkList(result.EVENTS)            
          }
        // }
        // else{
        //   setData([])
        // }
        setDataFetched(true)
        props.setLoading(false)
    }).catch(error => {
      props.setLoading(false)
    })  
  }

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.overflowY='scroll'
    props.setOpenCompanyProfile(false)
    fetchData()
  }, [id5, id4, id3, id2, id1])

  useEffect(() => {
    if(data.length)
      doSearch()
  }, [data])

  useEffect(() => {
    if(data.length)
      debouncedSearch()
  }, [keySelect, pulldownValue, searchInputValue, selectedAdvancedFilterOptions])  
  
  const doSearch=(value)=>{
    var keyword = null
    let searchOption = getSearchOption(keySelect)
    if(value){
      keyword = value
    }
    else{
      if(searchOption && (searchOption.TYPE == 'pulldown' || searchOption.TYPE == 'checkbox')){
        keyword = pulldownValue
      }
      else{
        keyword = searchInputValue
      }
    }
    if(!keyword) keyword = ''
    keyword = `${keyword}`
    var filteredItems = data;
    if(keyword == "" || keyword == '""' || !keyword){
      setFilteredItems(filteredItems)
      return;
    }
    if(keyword && keyword.trim() !== '') {
      filteredItems = data.filter((item)=>{
        var str = ''
        if(keySelect == "description"){
          str = `${item?.description?item?.description:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "company"){
          str = `${item?.company_name?`${item?.company_name}`.trim():''}`
          return (str.toLowerCase()==(keyword.trim().toLowerCase()))
        }
        else if(keySelect == "booth"){
          str = `${item?.booth_no?`${item?.booth_no}`.trim():''}`
          return (str.toLowerCase()==(keyword.trim().toLowerCase()))
        }
        else if(keySelect == "date"){
          var isBetween = false
          if(item.CLASSES?.[0]){
            let classItem = item.CLASSES?.[0]
            const classStart = moment(classItem['class_start']);
            const classEnd = moment(classItem['class_end']);
            const dateString = `${keyword.trim()}`  
            const date = moment(dateString, 'MM/DD/YYYY');  
            isBetween = date.isSame(classStart, 'day');
          }

          return isBetween
        }
        else if(keySelect == "Product Category"){
          var categories = item?.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }        
        else if(keySelect == 'New Products'){
          str = `${item?.NEW_PRODUCT?item?.NEW_PRODUCT:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }     
        else{
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }
      })      
    }
    setFilteredItems(filteredItems)
    setPage(1)
  }

  const debouncedSearch = debounce(doSearch, 300);

  const getSearchOption = (value)=>{
    if (!value) return false;
    for(var i = 0; i < standardSearchOptions?.length; i++){
      if(standardSearchOptions[i].ID == value){
        return standardSearchOptions[i]
      }
    }
    return false
  }

  var pageData = paginate(filteredItems, page_size, page);
  var banner = props.main.showSetup?.PUBLIC?.HEADER_BANNER;
  if(banner == "undefined") banner = null
  var download_show = true
  var contact_show = true
  if(props.main.showSetup?.PUBLIC?.DOWNLOAD_LINKS == 'hide'){
    download_show = false
  }
  if(props.main.showSetup?.PUBLIC?.CONTACT_INFO == 'hide'){
    contact_show = false
  }
  

  const fetchBookmarkList = (data)=>{
    { 
        try{
          var token =  getTokenPlanner();
          if(token){
            var url  = `${ESHOW_URL()}?method=getPlanner&token=${token}`
            axiosInstance.get(url).then(res=>{
                const result = res.data;
                if(result.SUCCESS){
                  props.setBookmarkList(result.BOOKMARKS)
                  var bookmarks = result.BOOKMARKS
                  var tmp = [...data];
                  for(var i = 0; i < tmp.length; i++){
                    for(var j = 0; j  < bookmarks?.length; j++){
                      if(bookmarks[j].TYPE == 'events' && tmp[i].KEY_ID == bookmarks[j].KEY_ID){
                        tmp[i].BOOKMARKED = 1
                        break;
                      }
                    }
                  }
                  setData(tmp);                
                }
                else{
  
                }
            }).catch(error => {
            })  
          }
        }
        catch(e){
        }
      }
    }
  
    const callBookmarkApi= async (exhibitor, value)=>{
      const _token = getTokenPlanner();
      var BOOKMARKS = props.main.bookmarkList?props.main.bookmarkList:[]
      if(value){
        if(exhibitor?.CLASSES?.[0])
        {
          var date = formatDateRange(exhibitor?.['CLASSES']?.[0]?.['class_start'], exhibitor?.['CLASSES']?.[0]?.['class_end'], 'CDT')
        }
        BOOKMARKS = [
          ...BOOKMARKS,
          {
            COMPANY_NAME: exhibitor?.COMPANY_NAME?exhibitor?.COMPANY_NAME:"",
            TYPE: "events",
            NOTES:"",
            BOOTHS:exhibitor.BOOTH_NO,
            EXHIBITOR_KEY:exhibitor?.EXHIBITOR_KEY?exhibitor?.EXHIBITOR_KEY:"" ,
            KEY_ID:exhibitor?.KEY_ID?exhibitor?.KEY_ID:"" ,
            TITLE:exhibitor?.TITLE?exhibitor?.TITLE:"",
            DATE:date
          }
        ]
      }
      else{
        BOOKMARKS = BOOKMARKS.filter((item, index) => `${item.KEY_ID}` !== `${exhibitor.KEY_ID}`)
      }
      
      props.setBookmarkList(BOOKMARKS)
      var postData =
      {
        SUCCESS:true,
        BOOKMARKS:BOOKMARKS
      };
  
      var formdata = {
        query:`${ESHOW_URL()}?method=putPlanner&token=${_token}`,
        postData: postData,
        returnResponse: true
      }
      var data = qs.stringify({
          request: JSON.stringify(formdata)
      });
      const options = {
        headers: {
          'body': '[{"company:","test"}]', 
          'Content-Type': 'application/json'
        }
      }
      var url = `${ESHOW_URL()}?method=putPlanner&token=${_token}`
      axiosInstance.post(url, JSON.stringify(postData), options).then(async res=>{
        const result = res.data;
        if(result.SUCCESS == true){
        }
        else{
          props.setOpenSnack(true);
          props.setSnackMsg(result.MESSAGE?result.MESSAGE:"Failed to save bookmark");
        }
        // props.setViewFile(filename);
      }).catch(error => {
      })
    }
    
    const doBookmark = (release)=>{
      if(release){
        try{
          const _token = getTokenPlanner();
          if((props.role !='admin') && (!_token || !_token)){
            props.setOpenLogin(true)
            return false;
          }
          var tmp = [...data];
          var value = 0;
          for(var i = 0; i < tmp.length; i++){
            if(tmp[i].KEY_ID == release.KEY_ID){
              tmp[i].BOOKMARKED = !tmp[i].BOOKMARKED
              value = tmp[i].BOOKMARKED
            }
          }
          callBookmarkApi(release, value)
          setData(tmp);
          // var tmp1 = [...filteredItems];
          // for(var i = 0; i < tmp1.length; i++){
          //   if(tmp1[i].EXHIBITOR_KEY == exhibitor.EXHIBITOR_KEY){
          //     tmp1[i].BOOKMARKED = !tmp1[i].BOOKMARKED
          //     callBookmarkApi(exhibitor, tmp1[i].BOOKMARKED)
          //   }
          // }
          // this.setFilteredItems(tmp1)
        }
        catch(e){
  
        }
      }
    }
    
    var sales_bookmarks_show = true
    if(props.main.showSetup?.PUBLIC?.BOOKMARKS == 'hide'){
      sales_bookmarks_show = false
    }
    
  return (
    <Box id="xhbt-main-container" className="App Client">
      <ToolBox {...props}/>
      <Box className="xhbt-data-box" style={{maxWidth: 1200, margin:'64px auto', paddingLeft: 10, paddingRight:10, marginTop:(banner && banner != ''?(150+64):64)}}>
        <Box textAlign={'center'}>
          <SearchBox/>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            {
              pageData.map((item, index)=>{
                return(
                  <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                    <Item className='event-card' variant="outlined" square style={{position:'relative', padding:0}}>
                        {item.HEADER_IMAGE &&
                        <>
                        {
                          item.HEADER_IMAGE?.includes(".mp4")?
                          <ReactPlayer controls muted={true} playing={true} className="" url={item.HEADER_IMAGE} width="100%" height="80px"/>:
                          <div style={{width:'100%'}}>
                            <img style={{width:'100%', objectFit:'cover'}} width="auto" height="100px" src={`${assetUrl(item.HEADER_IMAGE)}`}/>
                          </div>
                        }
                        </>
                        }
                        <Box style={{padding:8}}>
                          <Box sx={{textAlign:'right', display:'flex', paddingRight:'15px', justifyContent:'end'}}>
                            {item.DOCUMENT &&  download_show &&
                            <>
                              {item.DOCUMENT_TYPE == 'video'?              
                              <a className='round-icon-btn' style={{marginLeft:'auto',marginRight:'10px'}} target='_blank' href={item.DOCUMENT}>
                                <VideocamIcon style={{color:'white'}}/>
                              </a>:
                              <a className='round-icon-btn' style={{marginLeft:'auto',marginRight:'10px'}} target='_blank' download href={item.DOCUMENT}>
                                <DownloadIcon style={{color:'white'}}/>
                              </a>
                              }
                            </>
                            }
                            {sales_bookmarks_show&&
                              <button className="BookMarkButton" sx={{backgroundColor:'transparent !important',}} edge="end" onClick={()=>{ doBookmark(item)}} >
                                {
                                  item.BOOKMARKED?
                                  <BookmarkSharpIcon style={{color:'#e54839'}}/>:
                                  <BookmarkBorderSharpIcon />
                                }
                              </button>
                            }
                          </Box>
                          <Box mt={1}>
                            <b class="card-title">{item?.TITLE}</b>  
                            {
                              item?.CLASSES?.[0]&&
                              <div className='event-date'>Event Date: {formatDateRange(item?.['CLASSES']?.[0]?.['class_start'], item?.['CLASSES']?.[0]?.['class_end'], 'CDT')}</div>
                            }
                            {item.DESCRIPTION&&                      
                            <Box className='show-more-div' mt={1} style={{minHeight:'70px', textAlign:'left'}}>
                              {/* <ShowMore
                                  lines={4}
                                  more='Read More'
                                  less='Read Less'
                                  anchorClass=''
                              >
                                {item.DESCRIPTION} 
                              </ShowMore> */}
                              <ReactReadMoreReadLess
                                  charLimit={200}
                                  readMoreText={"Read more"}
                                  readLessText={"Read less"}
                              >
                                {item.DESCRIPTION} 
                              </ReactReadMoreReadLess>
                            </Box>
                            }
                          </Box>           
                          <Box mt={1} style={{textAlign: 'left'}}>
                            <h3>Speakers</h3>
                            {
                              item.SPEAKERS?.map((speaker, speakerInd)=>{
                                return(
                                  <Box display={'flex'}>
                                    <Box className='avatar-div' style={{marginRight:'15px'}}>
                                      {speaker.photo &&
                                        <>
                                        {
                                            <img style={{width:'50px', height:'50px', objectFit:'cover'}} width="50px" height="50px" src={`${assetUrl(speaker.photo)}`}/>
                                        }
                                        </>
                                      }
                                    </Box>
                                    <Box>
                                      <h4>{speaker.first_name} {speaker.last_name}</h4>
                                      <p>{speaker.job_title}</p>
                                    </Box>
                                  </Box>
                                )
                              })
                            }
                          </Box>   
                          <Box mt={2} style={{textAlign: 'left'}}>
                            <h3>Exhibitor</h3>
                            <Box display={'flex'}>
                              <Box className='' style={{marginRight:'15px',width:'50px', height:'50px'}}>
                                {item.logo_url &&
                                  <>
                                  {
                                      <img style={{width:'50px', height:'50px', objectFit:'contain'}} width="auto" height="100px" src={`${assetUrl(item.logo_url)}`}/>
                                  }
                                  </>
                                }
                              </Box>
                              <Box>
                                <h4>
                                  <a href="javascript:void(0)" onClick={()=>{openCompanyProfile(item)}}>
                                    {item.company_name}
                                  </a>
                                </h4>
                                {item.booth_no &&
                                <><span>Booth: {item.booth_no}</span><br/></>
                                }
                              </Box>
                            </Box>
                          </Box>   
                        </Box>
                    </Item>
                  </Grid>
                )
              })
            }
            {
              (!data || data.length == 0) && dataFetched && 
              <Box style={{textAlign:'center', width:'100%'}}>
                <label>No Exhibitor Event Found.</label>
              </Box>
            }
          </Grid>
        </Box>
      </Box>
      <Box mt={3} mb={8}>
        <Stack spacing={2}>
          <Pagination variant="outlined" shape="rounded" style={{justifyContent:'center'}} count={Math.ceil(data.length/page_size)} color="primary"  page={page} onChange={handleChangePage}/>
        </Stack>
      </Box>
      <Footer/>
      <LeftProfile groupOptions = {[]}/>
      {props.ui?.customStyles?.['loaded'] &&
      <LoadingOverlay
            active={props.main.loadingFlag}
            fadeSpeed = {100}
            styles={{
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                // background: 'rgb(229 229 229 / 92%)',
                background: 'transparent',
                position:'fixed',
                top: '49px',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
        </LoadingOverlay> 
        }
    </Box>
  );
}


const mapStateToProps = (state) => {
  return {
    main: state.main,
    booth_history: state.booth_history.present,
    ui: state.ui,
    cart: state.cart,
    searchbox: state.searchbox,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
      setCustomStyles: data=>dispatch(setCustomStyles(data)),
      setAuthInfo:  data=>dispatch(setAuthInfo(data)), 
      setLoading:  data=>dispatch(setLoading(data)),
      setOpenCompanyProfile:  data=>dispatch(setOpenCompanyProfile(data)),
      setSearchKeySelect:  data=>dispatch(setSearchKeySelect(data)),
      setSearchPulldownValue:  data=>dispatch(setSearchPulldownValue(data)),
      setSearchOptions:  data=>dispatch(setSearchOptions(data)),
      setBookmarkList:  data=>dispatch(setBookmarkList(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
